module.exports = __webpack_public_path__ + "media/typy/przyczepy@2x-3949428b.png";